/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
const DHL_FLEX_DIRECTION = {
    COLUMN: "column",
    COLOUM_REVERSE: "column-reverse",
    ROW: "row",
    ROW_REVERSE: "row-reverse",
};
const DHL_FLEX_JUSTIFY = {
    CENTER: "center",
    START: "start",
    END: "end",
    FLEX_START: "flex-start",
    FLEX_END: "flex-end",
    NORMAL: "normal",
    STRETCH: "stretch",
    SAFE_CENTER: "safe center",
    UNSAFE_CCENTER: "unsafe center",
    INHERIT: "inherit",
    INITIAL: "initial",
    REVERT: "revert",
    REVERT_LAYER: "revert-layer",
    UNSET: "unset",
    LEFT: "left",
    RIGHT: "right",
    SPACE_BETWEEN: "space-between",
    SPACE_AROUND: "space-around",
    SPACE_EVENLY: "space-evenly",
};
const DHL_FLEX_ALIGN = {
    CENTER: "center",
    START: "start",
    END: "end",
    FLEX_START: "flex-start",
    FLEX_END: "flex-end",
    NORMAL: "normal",
    STRETCH: "stretch",
    SAFE_CENTER: "safe center",
    UNSAFE_CCENTER: "unsafe center",
    INHERIT: "inherit",
    INITIAL: "initial",
    REVERT: "revert",
    REVERT_LAYER: "revert-layer",
    UNSET: "unset",
    BASELINE: "baseline",
    FIRST_BASELINE: "first baseline",
    LAST_BASELINE: "last baseline",
};
const DHL_FLEX_WRAP = {
    INHERIT: "inherit",
    INITIAL: "initial",
    REVERT: "revert",
    REVERT_LAYER: "revert-layer",
    UNSET: "unset",
    NO_WRAP: "nowrap",
    WRAP: "wrap",
    WRAP_REVERSE: "wrap-reverse",
};
const DHL_FLEX = {
    DIRECTION: DHL_FLEX_DIRECTION,
    JUSTIFY: DHL_FLEX_JUSTIFY,
    ALIGN: DHL_FLEX_ALIGN,
    WRAP: DHL_FLEX_WRAP,
};

export { DHL_FLEX as D };

//# sourceMappingURL=constants-95c3b239.js.map